import { createStructuredSelector, createSelector } from 'reselect';
import { capitalizeFirstWord } from 'swag-common/utils/strings';
import { layersSelector, logosSelector } from '../../../../../../../redux/logo/logo.selectors';
import { currentEmbellishmentMethodSelector, isAdditionalLogosAllowedSelector, isRebuildCBSProductModeSelector } from '../../../../../../../redux/product/product.selectors';
import { logoHandlingStatusSelector, logoLocationSelector, showOverlaySelector } from '../../../../../../../redux/logo-editing/logo-editing.selectors';
import { shouldShowCompanyArtFolderSelector } from '../../../../../../../redux/company-art-folder/company-art-folder.selectors';
const propsSelector = (_, props) => props;
export const isLogoUploadedSelector = createSelector(logosSelector, propsSelector, (logosMap, props) => {
  const logos = Object.values(logosMap);
  const view = props.view.id;
  return !!logos.length && !!logos.filter(({
    location
  }) => location === view).length;
});
export const singleViewLogosSelector = createSelector(layersSelector, logosSelector, propsSelector, (layers, logos, props) => {
  const viewLayers = layers[props.view.id] || [];
  return viewLayers.reduce((result, mediaId) => {
    if (logos[mediaId]) {
      result.push(logos[mediaId]);
    }
    return result;
  }, []);
});
const showProgressBarSelector = createSelector(logoHandlingStatusSelector, logoLocationSelector, propsSelector, (logoHandlingStatus, uploadingView, props) => Boolean(logoHandlingStatus && uploadingView === props.view.id));
const showLogosSelector = createSelector(isAdditionalLogosAllowedSelector, isLogoUploadedSelector, showProgressBarSelector, propsSelector, (isAdditionalLogosAllowed, isLogoUploaded, showProgressBar, props) => isAdditionalLogosAllowed && isLogoUploaded && !props.view.isDisabled || !isAdditionalLogosAllowed && isLogoUploaded && !showProgressBar && !props.view.isDisabled);
const showAdditionalLogoUploadSelector = createSelector(isAdditionalLogosAllowedSelector, isLogoUploadedSelector, isRebuildCBSProductModeSelector, propsSelector, (isAdditionalLogosAllowed, isLogoUploaded, isEditCBSProductMode, props) => isLogoUploaded && isAdditionalLogosAllowed && !isEditCBSProductMode && !props.view.isDisabled);
const showUploadLogoButtonSelector = createSelector(isLogoUploadedSelector, showProgressBarSelector, isRebuildCBSProductModeSelector, propsSelector, (isLogoUploaded, showProgressBar, isEditCBSProductMode, props) => (!isLogoUploaded || showProgressBar || !!props.view.isDisabled) && !isEditCBSProductMode);
const showRemoveLogoButtonSelector = createSelector(isRebuildCBSProductModeSelector, isEditCBSProductMode => !isEditCBSProductMode);
const tooltipTextSelector = createSelector(propsSelector, currentEmbellishmentMethodSelector, (props, currentEmbellishmentMethod) => {
  if (!props.view.isDisabled) {
    return;
  }
  if (currentEmbellishmentMethod) {
    return `Unavailable for ${capitalizeFirstWord(currentEmbellishmentMethod.name)} decoration method.`;
  }
  return 'Please select your decoration method in order to upload your design.';
});
export const mapStateToProps = createStructuredSelector({
  logos: singleViewLogosSelector,
  showOverlay: showOverlaySelector,
  shouldShowCompanyArtFolder: shouldShowCompanyArtFolderSelector,
  showProgressBar: showProgressBarSelector,
  showLogos: showLogosSelector,
  showAdditionalLogoUpload: showAdditionalLogoUploadSelector,
  showUploadLogoButton: showUploadLogoButtonSelector,
  showRemoveLogoButton: showRemoveLogoButtonSelector,
  tooltipText: tooltipTextSelector
});